import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurFormulatedStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19916" id="our-story-standards" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={ref} className={cn("relative mx-auto w-full max-w-xl lg:max-w-none transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            {}
            <div className="relative z-10 w-[85%] rounded-2xl overflow-hidden shadow-2xl border border-white/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1607036/img/custom_rtd_facility_interior.png" alt="Custom RTD Co. state-of-the-art FDA-registered canning facility interior" className="w-full h-auto object-cover aspect-[4/5]" />
            </div>

            {}
            <div className="absolute bottom-[-2rem] right-0 w-[55%] z-20 rounded-2xl overflow-hidden shadow-2xl border-4 border-background">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1607036/img/canning_line_precision_close.png" alt="Close-up of high-speed counter-pressure canning line technology" className="w-full h-auto object-cover aspect-square" />
            </div>

            {}
            <div className="absolute -top-8 -left-8 w-24 h-24 bg-primary/20 rounded-full blur-2xl -z-10" />
            <div className="absolute bottom-12 right-12 w-32 h-32 bg-accent/30 rounded-full blur-3xl -z-10" />
          </div>

          {}
          <div className={cn("flex flex-col justify-center space-y-8 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold font-sans text-foreground tracking-tighter">
                Built on Quality & Precision
              </h2>
              <div className="w-20 h-1.5 bg-primary rounded-full" />
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-sans max-w-[70ch]">
              <p>
                At Custom RTD Co., we define excellence through the lens of technical precision. 
                What began as a commitment to superior carbonation has evolved into a 
                full-scale FDA-registered operation dedicated to functional beverage innovation.
              </p>
              <p>
                By merging state-of-the-art counter-pressure canning with rigorous compliance 
                standards, we ensure every can meets the highest benchmarks. Our facility 
                operates on three core pillars: 
                <span className="text-foreground font-medium"> Technical Integrity, Scalability, and Transparency.</span>
              </p>
              <p>
                We don't just fill cans; we engineer liquid experiences. From low-MOQ 
                adaptogen seltzers to complex probiotic fizzes, our team provides the 
                technical backbone your brand needs to scale securely in the wellness market.
              </p>
            </div>

            <div className="pt-4">
              <p className="font-sans text-3xl text-foreground font-semibold">
                Marcus Chen
              </p>
              <p className="text-xs text-primary font-mono mt-1 font-medium uppercase tracking-widest">
                Founder & Operations Director
              </p>
            </div>

            <div className="pt-6">
              <Button asChild variant="outline" className="rounded-full px-10 py-7 text-base border-primary/30 hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                <Link to="/AboutPage">Explore Our Standards</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}